export default __webpack_public_path__ + "b739e5c4df46f6d1f64f131dbe778278.png";